import {
  Button,
  CircularProgress,
  InputAdornment,
  Paper,
  TextField,
} from '@material-ui/core';
import WeightDialog from 'components/Dialog/WeightDialog/WeightDialog';
import SelectState from 'components/FormInputs/SelectCity';
import SelectCargo from 'components/Select/SelectCargo';
import React, { useEffect, useState } from 'react';
import tonnageIcon from 'assets/svg/tonnage.svg';
import FleetsTextFields from 'components/TextFields/FleetsTextFields';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { useFreight } from 'useStores/useFreight';
import { __ } from 'utils/i18n';
import { formatNumber } from 'fns';
import { toEN } from 'fns';
import useValidator from 'hooks/useValidator';
import { TYPES } from 'hooks/useValidator';
import axios from 'api/axios';
import useToast from 'hooks/useToast';
import { useQuery } from 'react-query';
import { useParams, useLocation } from 'react-router-dom';
import PriceWithLabel from 'components/TextFields/PriceWithLabel';
import CallIcon from '@material-ui/icons/Call';

const EditForm = () => {
  const toast = useToast();
  const [weightDialog, setWeightDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const setEditedOrderForm = useFreight((state) => state.setEditedOrderForm);
  const editOrderItems = useFreight((state) => state.editOrderItems);
  const resetEditOrderForm = useFreight((state) => state.resetEditOrderForm);
  const { orderId } = useParams();

  const validators = {
    origin: [{ type: TYPES.REQUIRED }],
    destination: [{ type: TYPES.REQUIRED }],
    cargoType: [{ type: TYPES.REQUIRED }],
    weight: [{ type: TYPES.REQUIRED }],
    fleetType: [{ type: TYPES.REQUIRED }],
    basePrice: [{ type: TYPES.REQUIRED }],
    phone: [{ type: TYPES.REQUIRED }],
  };
  const [errors, validate] = useValidator(validators);

  const handleClose = (data) => {
    changeFildes(data.weight, 'weight');
    changeFildes(data.weightType, 'weightType');
    setWeightDialog(false);
  };

  const changeFildes = (data, field) => {
    if (field === 'origin' || field === 'destination') {
      return setEditedOrderForm(
        { city: data, address: '', zipcode: '' },
        field
      );
    }
    if (field === 'fleetType') {
      return setEditedOrderForm(data, 'fleetType');
    }
    return setEditedOrderForm(data, field);
  };

  const submitForm = async () => {
    try {
      setLoading(true);
      if (
        validate({
          origin: editOrderItems.origin,
          destination: editOrderItems.destination,
          cargoType: editOrderItems.cargoType,
          weight: editOrderItems.weight,
          fleetType: editOrderItems.fleetType.length > 0,
          // basePrice: editOrderItems.basePrice,
          phone: editOrderItems.phone,
        })
      ) {
        const _data = {
          freight: editOrderItems._id,
          origin: editOrderItems.origin.city._id,
          destination: editOrderItems.destination.city._id,
          cargoType: editOrderItems.cargoType._id,
          weight: editOrderItems.weight,
          weightType: editOrderItems.weightType, // Ton or Kg
          // fleetOptions: editOrderItems.fleetType?.[0]._id,
          fleetOptions: editOrderItems?.fleetType?.map((item) => item?._id),
          basePrice: toEN(editOrderItems.basePrice),
          priceBasedWeight:
            editOrderItems.priceBasedWeight === 'perTon' ? true : false,
          description: editOrderItems?.description,
          phone: editOrderItems.phone,
        };
        const res = await axios.put(
          `/api/v1/admin/freight/orders/${orderId}`,
          _data
        );
        if (res.data.ok) {
          toast.success('سفارش با موفقیت ثبت شد');
          // resetEditOrderForm();
        }
      } else {
        throw 'فیلدهای مشخص شده را اصلاح فرمائید';
      }
    } catch (error) {
      console.error(error);
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => resetEditOrderForm();
  }, []);

  return (
    <div className="row g-3 mt-4">
      <div className="col-sm-6 col-12">
        <SelectState
          name={'origin'}
          city={editOrderItems.origin?.city || null}
          onSelect={(data) => changeFildes(data, 'origin')}
          placeholder={'انتخاب مبدا بارگیری'}
          error={errors?.origin || false}
          helperText={errors?.origin ? 'نام شهر را بایستی وارد نمائید' : ''}
        />
      </div>
      <div className="col-sm-6 col-12">
        <SelectState
          city={editOrderItems.destination?.city || null}
          onSelect={(data) => changeFildes(data, 'destination')}
          placeholder={'انتخاب مقصد'}
          error={errors?.destination || false}
          helperText={
            errors?.destination ? 'نام شهر را بایستی وارد نمائید' : ''
          }
        />
      </div>
      <div className="col-sm-6 col-12">
        <SelectCargo
          cargo={editOrderItems.cargoType || null}
          onSelect={(data) => changeFildes(data, 'cargoType')}
          error={errors?.cargoType || false}
          helperText={
            errors?.cargoType ? 'نوع محموله را بایستی وارد نمائید' : ''
          }
        />
      </div>
      <div className="col-sm-6 col-12">
        <TextField
          name="weight"
          onClick={() => setWeightDialog(true)}
          variant="outlined"
          color="secondary"
          placeholder="وزن محموله"
          size="small"
          fullWidth
          defaultValue={''}
          error={errors?.weight || false}
          helperText={errors?.weight ? 'وزن محموله را بایستی وارد نمائید' : ''}
          value={`${editOrderItems?.weight || 0} ${__(
            editOrderItems?.weightType || 'Ton'
          )}`}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <img src={tonnageIcon} alt="" height={25} width={25} />
              </InputAdornment>
            ),
          }}
        />
        {weightDialog && <WeightDialog onClose={handleClose} />}
      </div>
      <div className="col-12 col-sm-6">
        <FleetsTextFields
          name={'fleetType'}
          size={'small'}
          weight={editOrderItems.weight || 0}
          weightType={editOrderItems.weightType || 'Ton'}
          error={errors?.fleetType || false}
          helperText={
            errors?.fleetType ? 'نوع ناوگان را بایستی وارد نمائید' : ''
          }
          selection={editOrderItems.fleetType || []}
          onChange={(data) => {
            changeFildes(data, 'fleetType');
          }}
        />
      </div>
      <div className="col-12 col-sm-6">
        <TextField
          name="phone"
          variant="outlined"
          color="secondary"
          placeholder="شماره تلفن جهت هماهنگی"
          size="small"
          fullWidth
          defaultValue={editOrderItems?.phone || null}
          error={errors?.phone || false}
          value={editOrderItems?.phone || null}
          helperText={
            errors?.phone ? 'شماره تلفن جهت هماهنگی را بایستی وارد نمائید' : ''
          }
          onChange={(e) => {
            changeFildes(e.target.value, 'phone');
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CallIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className="col-12">
        <div className="d-flex justify-content-between">
          {/* <TextField
            name={'basePrice'}
            error={errors?.basePrice || false}
            helperText={errors?.basePrice ? 'کرایه را بایستی وارد نمائید' : ''}
            className="w-50"
            variant="outlined"
            placeholder="کرایه "
            onChange={(e) => changeFildes(e.target.value, 'basePrice')}
            size="small"
            value={formatNumber(toEN(editOrderItems.basePrice) || '0')}
          /> */}
          <PriceWithLabel
            position="down"
            rows={10}
            fullWidth
            name="basePrice"
            error={errors?.basePrice || false}
            helperText={errors?.basePrice ? 'کرایه را بایستی وارد نمائید' : ''}
            variant="outlined"
            onChange={(e) => changeFildes(e.target.value, 'basePrice')}
            label="صافی راننده"
            size="small"
            value={
              editOrderItems.basePrice ? toEN(editOrderItems.basePrice) : ''
            }
          />
          <FormControl className="w-50" component="fieldset">
            <RadioGroup
              className="justify-content-center"
              row
              aria-label="position"
              name="position"
              defaultValue="totalFee"
              value={
                editOrderItems?.priceBasedWeight === 'perTon'
                  ? 'perTon'
                  : 'totalFee'
              }
              onChange={(e) => changeFildes(e.target.value, 'priceBasedWeight')}
            >
              <FormControlLabel
                value="totalFee"
                control={<Radio color="primary" />}
                label="کرایه کل"
                labelPlacement="end"
              />
              <FormControlLabel
                value="perTon"
                control={<Radio color="primary" />}
                label="هر تن"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>
      <div className="col-12">
        <TextField
          value={editOrderItems.description || ''}
          variant="outlined"
          color="secondary"
          placeholder="توضیحات"
          onChange={(e) => changeFildes(e.target.value, 'description')}
          fullWidth
          minRows={5}
          multiline
        />
      </div>
      <div className="col-12">
        <Button
          onClick={submitForm}
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading}
          endIcon={loading && <CircularProgress size={10} />}
        >
          ویرایش سفارش
        </Button>
      </div>
    </div>
  );
};

export default EditForm;
